import { useContext } from 'react'

import { ParametrizationCurveWeightContext } from '@provider/Parametrization/CurveWeightProvider'

import { ICurveWeightProvider } from '@base/@types/providers/Parametrization/CurveWeightProvider'
export default function useParametrizationCurveWeight(): ICurveWeightProvider {
  const context = useContext(ParametrizationCurveWeightContext)

  return context
}
